import { render, staticRenderFns } from "./DemoBadgePosition.vue?vue&type=template&id=66e59eea&"
import script from "./DemoBadgePosition.vue?vue&type=script&lang=js&"
export * from "./DemoBadgePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VBadge,VImg})
